import { render, staticRenderFns } from "./psTabFloorItem.vue?vue&type=template&id=64c23c09&scoped=true&"
import script from "./psTabFloorItem.vue?vue&type=script&lang=js&"
export * from "./psTabFloorItem.vue?vue&type=script&lang=js&"
import style0 from "./psTabFloorItem.vue?vue&type=style&index=0&id=64c23c09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c23c09",
  null
  
)

export default component.exports